import React from 'react'
import hope from '../img/hope.jpg'

const Banner = () => {
    return (
        <>

            <div className='mydocts'>

                <h1>Doctors, Life Savers</h1>
                <p> Welcome to Hope Rise Multi-Specialty Hospital, a trusted healthcare provider and a unit of Hope Rise Hospital Private Limited. We are dedicated to delivering comprehensive, compassionate care across a wide range of medical specialties. Established with a vision to provide top-quality healthcare to individuals and families, we are committed to setting new standards in medical excellence, patient care, and innovative treatment.</p>
            </div>


            <div className='banners'>
                <img src={hope} />
            </div>

        </>
    )
}

export default Banner
